export default __webpack_public_path__ + "static/media/Superior.9adb9e08.jpg";